import type { VisibilityState } from '@tanstack/react-table';
import type { CertificationRecord } from '../../../types/driInsights';
import { exportCsvWithVisibleColumns } from '../../../utils/csvExport';

const CERTIFICATIONS_TABLE_COLUMN_ORDER = [
  'employee_name',
  'certification_name',
  'issue_date',
  'expiry_date',
  'certification_provider',
  'status',
] as const;

const CERTIFICATIONS_TABLE_CSV_LABELS: Record<string, string> = {
  employee_name: 'Employee',
  certification_name: 'Certification Name',
  issue_date: 'Issue Date',
  expiry_date: 'Expiry Date',
  certification_provider: 'Provider',
  status: 'Status',
};

function getCertificationRowCellCsv(
  row: CertificationRecord,
  columnId: string,
  formatDate: (dateString: string | null | undefined) => string
): string {
  switch (columnId) {
    case 'employee_name':
      return row.employee_name ?? '';
    case 'certification_name':
      return row.certification_name ?? '';
    case 'issue_date':
      return formatDate(row.issue_date);
    case 'expiry_date':
      return formatDate(row.expiry_date);
    case 'certification_provider':
      return row.certification_provider ?? '';
    case 'status':
      return row.status ?? '';
    default:
      return '';
  }
}

/** All filtered + sorted rows (not paginated), columns per Toggle Columns. */
export function exportCertificationsTableToCsv(options: {
  rows: CertificationRecord[];
  columnVisibility: VisibilityState;
  formatDate: (dateString: string | null | undefined) => string;
  filenameBase?: string;
}): void {
  const { rows, columnVisibility, formatDate, filenameBase = 'dri-insights-certifications' } = options;
  if (!rows.length) return;

  exportCsvWithVisibleColumns({
    rows,
    columnVisibility,
    columnIdsInOrder: CERTIFICATIONS_TABLE_COLUMN_ORDER,
    columnLabels: CERTIFICATIONS_TABLE_CSV_LABELS,
    getCellText: (row, columnId) => getCertificationRowCellCsv(row, columnId, formatDate),
    filenameBase,
  });
}
